/**
 * Created by stas on 5/22/2017.
 */
export class BaseEntity<T>{
    public Id? : T = null;
    public Created? : Date = null;
    public Updated? : Date = null;
}


// WEBPACK FOOTER //
// ./app/objects/common/baseEntity.ts